module.exports = __webpack_public_path__ + "static/img/show-paging.4c38410c.png";